Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentNewsTextView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_news_text"]
  className: 'sc-news-text'

  initialize: (options = {}) ->
    @socialContent = options.socialContent

  render: ->
    @$el.html @template
      title:
        text: @socialContent.getValue('title')
        url: @socialContent.getValue('finalurl')
      source:
        name: @socialContent.getValue('source')
        homePage: @socialContent.getValue('home')
      summary: @socialContent.getValue('summary')
      body: @socialContent.enhancedNewsBody()
    this

